require('./userGroupEditorHeader.i18n.json');
require('./userGroupEditorHeader.tpl.html');
require('./userGroupEditorHeaderController.js');
require('./userGroupActionsUtil.js');

const UserGroupEditorHeaderController = {
    templateUrl: '/ui/userGroupEditor/header/userGroupEditorHeader.tpl.html',
    controller: 'userGroupEditorHeaderController',
    bindings: {
        userGroupName:'<'
    }
};

angular.module('umCore')
    .component('uiUserGroupEditorHeader', UserGroupEditorHeaderController);
